// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Rgwn","header":"PatientQuestionnaire_header__2V5-q","info":"PatientQuestionnaire_info__Lzxjf"};